const CRED_PAYMENT_METHOD_PREFIX = "pm_cred";

export const CRED_PAYMENT_METHOD_TEST_IDS = {
    CONTAINER: `${CRED_PAYMENT_METHOD_PREFIX}_container`,
    ICON: `${CRED_PAYMENT_METHOD_PREFIX}_icon`,
    NAME: `${CRED_PAYMENT_METHOD_PREFIX}_name`,
    TICK: `${CRED_PAYMENT_METHOD_PREFIX}_tick`,
    DISABLE_MESSAGE: `${CRED_PAYMENT_METHOD_PREFIX}_disable_msg`,
    PAY_BUTTON: `${CRED_PAYMENT_METHOD_PREFIX}_pay_btn`,
};
